import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useIsDesktop } from "@vk-hr-tek/ui/hooks";
import { Button } from "@vk-hr-tek/ui/Button";
const FormButton = (t0)=>{
    const $ = c(6);
    const { children, testId, disabled: t1, loading: t2 } = t0;
    const disabled = void 0 === t1 ? false : t1;
    const loading = void 0 === t2 ? false : t2;
    const isDesktop = useIsDesktop();
    const t3 = isDesktop ? "large" : "medium";
    let t4;
    if ($[0] !== children || $[1] !== disabled || $[2] !== loading || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ jsx(Button, {
            className: "qaSubmitButton",
            disabled: disabled,
            fullWidth: true,
            loading: loading,
            size: t3,
            type: "submit",
            testId: testId,
            children: children
        });
        $[0] = children;
        $[1] = disabled;
        $[2] = loading;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
export { FormButton };
